import { getopenuserlist } from "@/port/clientSide/multipleChoice";
import { cloneDeep } from 'lodash';
import { getLabelColor } from '@/api/instrumentControl'

export const getUserMoreInfo = async (tableData = [], canvasChildren = []) => {
  const data = cloneDeep(tableData)
  const canvasChildrenObj = {}
  canvasChildren.forEach(item => {
    canvasChildrenObj[item.title] = cloneDeep(item)
  })
  const userIdList = []
  data.forEach(dataItem => {
    for(let key in dataItem) {
      const item = dataItem[key]
      key = key.search('_') !== -1 ? key.split('_')[0] :  key
      // 判断是不是联系人
      if (Array.isArray(item) && item.length > 0 && item[0] && item[0].userId) {
        if (canvasChildrenObj[key] && canvasChildrenObj[key].userKey) {
          const userKey = canvasChildrenObj[key].userKey
          // 如果存在'-data'就使用表单的数据 不用获取最新的
          if (userKey.search('-data') === -1) {
            item.forEach(iter => { 
              if (iter.userId && !userIdList.includes(iter.userId)) {
                userIdList.push(iter.userId)
              }
            })
          }
        }
      } else if (key === '申请人') {
        if (dataItem.userId && !userIdList.includes(dataItem.userId)) {
          userIdList.push(dataItem.userId)
        }
      }
    }
  })
  // 存在用户再发起请求
  if (userIdList.length > 0) {
    const res = await getopenuserlist({userids: userIdList.join(), curpage: 0, pagesize: 1000})
    const userData = {} 
    res.data.forEach(item => {
      userData[item.userId] = item
    })
    data.forEach(dataItem => {
      for(const key in dataItem) {
        const item = dataItem[key]
        let temp_data
        // 判断是不是联系人
        if (Array.isArray(item) && item.length > 0 && item[0] && item[0].userId) {
          item.forEach((iter, index) => { 
            if (userData[iter.userId]) {
              temp_data = { ...dataItem[key][index], ...userData[iter.userId] }
              dataItem[key][index] = temp_data
            }
          })
        } else if (key === '申请人') {
          if (userData[dataItem.userId]) {
            temp_data = { ...dataItem[key], ...userData[dataItem.userId] }
            dataItem[key] = [temp_data]
          }
        }
      }
    })
  } 
  return data
}

export const cardLabelColor = (val, filed) => {
  if (!filed.filedTagInfo) return
  if (!filed.filedTagInfo.isColorTag) return
  const list = filed.filedTagInfo.list
  const colorType = filed.filedTagInfo.colorType
  const obj = getLabelColor({options: list}, val, undefined, colorType)
  if (obj.display) {
    delete obj.display
    delete obj.padding
  }
  return obj
}